import { styled } from '@stitches/configed';

export const TypographyStyled = styled('div', {
  fontWeight: 400,

  '.font-bold': {
    fontWeight: 700,
  },
  '.italic': {
    fontStyle: 'italic',
  },
  '.underline': {
    textDecorationLine: 'underline',
  },
  '.line-through': {
    textDecorationLine: 'line-through',
  },
  '.underline-line-through': {
    textDecorationLine: 'underline line-through',
  },

  // color:
  '.text-gray': {
    color: 'rgb(107 114 128)',
  },
  '.text-brown': {
    color: 'rgb(159, 107, 83)',
  },
  '.text-orange': {
    color: 'rgb(249 115 22)',
  },
  '.text-yellow': {
    color: 'rgb(234 179 8)',
  },
  '.text-green': {
    color: 'rgb(34 197 94)',
  },
  '.text-blue': {
    color: 'rgb(59 130 246)',
  },
  '.text-purple': {
    color: 'rgb(168 85 247)',
  },
  '.text-pink': {
    color: 'rgb(236 72 153)',
  },
  '.text-red': {
    color: 'rgb(239 68 68)',
  },

  // background:
  '.bg-gray': {
    backgroundColor: 'rgb(243 244 246)',
  },
  '.bg-brown': {
    backgroundColor: 'rgb(236 226 217)',
  },
  '.bg-orange': {
    backgroundColor: 'rgb(255 237 213)',
  },
  '.bg-yellow': {
    backgroundColor: 'rgb(254 249 195)',
  },
  '.bg-green': {
    backgroundColor: 'rgb(220 252 231)',
  },
  '.bg-blue': {
    backgroundColor: 'rgb(219 234 254)',
  },
  '.bg-purple': {
    backgroundColor: 'rgb(243 232 255)',
  },
  '.bg-pink': {
    backgroundColor: 'rgb(252 231 243)',
  },
  '.bg-red': {
    backgroundColor: 'rgb(254 226 226)',
  },
});
